import pkg from '../package.json';

// Unico punto da cui leggere la versione: aggiornala solo qui (e nel
// corrispondente server/package.json) quando rilasci una nuova versione.
export const APP_VERSION = pkg.version;
